module.exports = __webpack_public_path__ + "static/media/user_profile.a7b35b11.png";